import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=3be7fc78&scoped=true"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"
import style0 from "./formDetail.vue?vue&type=style&index=0&id=3be7fc78&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7fc78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be7fc78')) {
      api.createRecord('3be7fc78', component.options)
    } else {
      api.reload('3be7fc78', component.options)
    }
    module.hot.accept("./formDetail.vue?vue&type=template&id=3be7fc78&scoped=true", function () {
      api.rerender('3be7fc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/components/formDetail.vue"
export default component.exports